import api from '@/services/api'

export default {
  getShop() {
    return api.get(`shop/current/`)
        .then(response => response.data)
  },
  editShop(shop) {
    return api.put(`shop/${shop.id}/`, shop)
        .then(response => response.data)
  },
  setToken(data) {
    return api.post(`shop/set_token/`, data)
        .then(response => response.data)
  }
}